<template lang="pug">
  .container
    .roll-order-infos(ref="rollOrder")
      div(v-for="item in rollPool") {{item}} 1分钟前办理
    .header
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/ningxia/o-header.png?x-oss-process=style/414_jpeg_zoom")
      el-form.mobile-form
        el-form-item
          el-input(type="text", v-model="form.mobile", placeholder="请输入宁夏移动手机号")
        el-form-item(v-if="isCheckMobile")
          el-row
            el-col(:span="13")
              el-input(type="text", placeholder="请输入短信验证码", v-model="form.verifyCode", maxlength="6")
            el-col(:span="9", :offset="1")
              el-button(type="warning", :disabled="leftSendTime > 0", @click="sendVerifyCode")
                span(v-if="leftSendTime <= 0") 获取验证码
                span(v-else) {{leftSendTime}}秒后可重试
        el-form-item.btn-submit
          img(src="../../../public/images/ningxia/o-button.png", v-if="!isCheckMobile", @click="checkMobile")
          img(src="../../../public/images/ningxia/o-confirm-button.png", v-else, @click="handleSubmit")
        el-form-item.price-desc 注：24.9元20GB流量包、1个月热门视频会员。每月资费24.9元，订购首月免费（扣费24.9元后即时返还等额话费），次月正常收费。
        el-form-item.protocol
          el-checkbox(v-model="agreeProtocol") 我已同意并阅读
          el-link(type="primary", @click="showProtocol") 《协议内容》
    .img-desc
      img(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/ningxia/o-desc1.png?x-oss-process=style/414_jpeg_zoom")
    .notice
      .title ········活动说明········
      ul
        li(v-for="(notice, index) in notices", :key="index")
          .num {{index + 1}}.
          p.content {{notice}}
    //- .notice.page-inner
    //-   ul
    //-     li(v-for="(notice, index) in notices", :key="index", v-if="index < 1 || showMoreNotice")
    //-       .num {{index + 1}}.
    //-       p.content {{notice}}
    //-   .show-more(v-if="!showMoreNotice", @click="showMoreNotice = true") 点击查看更多服务协议
    el-dialog(width="90%", title="协议内容", :visible.sync="protocolVisible")
      .protocal-content
        ul
          li(v-for="(notice, index) in notices", :key="index")
            .num {{index + 1}}.
            p.content {{notice}}
    el-dialog(width="90%", title="限时福利", :visible.sync="cardADVisible")
      .ad(@click="toCardLink")
        img(src="../../../public/images/200G.png")
        el-button.btn-submit 点 击 立 即 领 取
</template>

<script>

// 推啊=TUIA、豆盟=DOUMENG、快手=KUAISHOU
export default {
  data() {
    return {
      errlog: '',
      shareNoticeVisiable: false,
      dialogVisible: false,
      showMoreNotice: false,
      leftSendTime: 0,
      isCheckMobile: false,
      channel: 'TUIA',
      failCount: 0,
      rollPool: ['136****3827', '137****1974'],
      rollOrderTop: 0.5,
      protocolVisible: false,
      cardADVisible: false,
      agreeProtocol: true,
      form: {
        carrierId: 3,
        mobile: '',
        verifyCode: '',
        userId: null,
        sharerId: null
      },
      notices: [
        '资费说明：24.9元/月，订购首月免费（扣费24.9元后即时返还等额话费），次月正常收费。',
        '产品说明：本产品包含20GB定向流量+视频会员6选一，20GB定向流量为爱奇艺、优酷视频、腾讯视频、咪咕视频、芒果TV、PPTV视频、快手、抖音APP定向流量，视频会员为爱奇艺、优酷视频、腾讯视频、咪咕视频、芒果TV、PPTV视频月卡会员任选一',
        '合约说明：本产品为连续包月产品，订购成功后立即生效。订购首月不可退订，第二个月可退订。如退订，退订次月1日生效，订购后不可回退。',
        '流量说明：20GB定向流量优先级高于主套餐、流量可选包，产品内所含流量不可结转，不可转赠，不可分享，当月月底失效。',
        'VIP权益说明：客户办理成功之后且不退订业务，即可每月领取一次会员权益，客户需主动关注微信公众号“冰蓝流量”输入“宁夏移动”进入权益领取界面领取，权益自选择之日起，30个自然日内有效，各大权益平台有效期不相同，以实际权益提供方显示有效期为准。若用户退订了本业务，则次月不再享有视频会员领取资格。',
        '本产品最终解释权归宁夏移动所有，如有疑问详询10086。'
      ],
      selectedPackage: {},
      packageList: [
        {
          goodsCode: 'TUIA08260001',
          confirmInfo: '首月免费体验，月费24.9元，次月3日前赠等额话费24.9元，包含20GB定向流量+视频会员6选一'
        }
      ]
    }
  },
  mounted() {
    this.handleSelected(this.packageList[0])
    this.failCount = 0
    setTimeout(() => {
      this.rollOrder()
    }, 2000)
  },
  methods: {
    rollOrder() {
      if (this.rollOrderTop < 1.2) {
        this.$refs.rollOrder.querySelector('div').style.marginTop = `-${this.rollOrderTop}rem`
        setTimeout(() => {
          this.rollOrderTop += 0.2
          this.rollOrder()
        }, 80)
      } else {
        let _numPrefix = [138, 137, 136]
        let _num = 9999 - Math.floor(Math.random() * 8999)
        this.rollPool.push(`${_numPrefix[Math.floor(Math.random() * 3)]}****${_num}`)
        this.$refs.rollOrder.querySelector('div').style.marginTop = '0.5rem'
        this.rollPool.splice(0, 1)
        this.rollOrderTop = 0.5
        setTimeout(() => {
          this.rollOrder()
        }, 2000)
      }
    },
    toCardLink() {
      window._czc.push(['_trackEvent', '宁夏', '点击号卡广告-v2', '号卡', 1, '成功'])
      location.href = '/self.html#/card/hmcard?channel=alipayself&utm=tuiajgnxjgvf';
    },
    handleSelected(selectedPackage) {
      this.selectedPackage = selectedPackage
    },
    showProtocol() {
      this.protocolVisible = true
      if (window._czc) {
        window._czc.push(['_trackEvent', '宁夏', '查看协议-v2', '流量权益包', 1, '成功'])
      }
    },
    sendVerifyCode() {
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      this.$service.CarrierService
        .sendVerifyCode({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel
        })
        .then(res => {
          if (res.data.success) {
            if (window._czc) {
              window._czc.push(['_trackEvent', '宁夏', '获取验证码-v2', '流量权益包', 1, '成功'])
            }
            this.leftSendTime = 60
            this.setSendTimeLeft()
            this.$message({
              type: 'success',
              message: '验证码已发送'
            })
          } else {
            if (window._czc) {
              window._czc.push(['_trackEvent', '宁夏', '获取验证码-v2', '流量权益包', 0, '失败'])
            }
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          if (window._czc) {
            window._czc.push(['_trackEvent', '宁夏', '获取验证码-v2', '流量权益包', 0, '失败'])
          }
          this.$message({
            type: 'error',
            message: '系统错误，或请输入正确的手机号码'
          })
        })
    },
    setSendTimeLeft() {
      if (this.leftSendTime > 0) {
        this.leftSendTime -= 1
        setTimeout(() => {
          this.setSendTimeLeft()
        }, 1000)
      }
    },
    showConfirm() {
      this.dialogVisible = true
    },
    checkMobile() {
      if(!this.agreeProtocol) {
        this.$message({
          type: 'warning',
          message: '请阅读《协议内容》，并勾选'
        })
        return;
      }
      this.form.mobile = this.form.mobile.trim()
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          channel: this.channel,
          goodsCode: this.selectedPackage.goodsCode,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.isCheckMobile = true
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
            if (res.data.message.indexOf('输入的号码无效') > -1) {
              this.cardADVisible = true
            }
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleSubmit() {
      this.dialogVisible = false
      this.form.mobile = this.form.mobile.trim()
      this.form.verifyCode = this.form.verifyCode.trim()
      if(!this.agreeProtocol) {
        this.$message({
          type: 'warning',
          message: '请阅读《协议内容》，并勾选'
        })
        return;
      }
      if(!this.$REGEX.mobile.test(this.form.mobile)) {
        this.$message({
          type: 'warning',
          message: '请填写正确的手机号码'
        })
        return;
      }
      if(this.form.verifyCode.length === 0) {
        this.$message({
          type: 'warning',
          message: '请填写短信验证码'
        })
        return;
      }
      if(this.form.verifyCode.length != 6) {
        this.$message({
          type: 'warning',
          message: '请填写6位验证码'
        })
        return;
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在处理中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .checkMobilePackage({
          carrierId: this.form.carrierId,
          mobile: this.form.mobile,
          goodsCode: this.selectedPackage.goodsCode,
          verifyCode: this.form.verifyCode,
          channel: this.channel,
          userId: this.form.userId || 25995   // 缺省冀的用户ID
        })
        .then(res => {
          if (res.data.success) {
            this.addMobilePackage()
          } else {
            this.$message({
              type: 'warning',
              message: res.data.message
            })
          }
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '请求过程中发生错误，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    addMobilePackage() {
      let _formData = {
        carrierId: this.form.carrierId,
        mobile: this.form.mobile,
        userId: this.form.userId || 25995,   // 缺省冀的用户ID,
        goodsCode: this.selectedPackage.goodsCode,
        verifyCode: this.form.verifyCode,
        channel: this.channel
      }
      if (this.form.sharerId) {
        _formData.sharerId = this.form.sharerId
      }
      let _loading = this.$loading({
        lock: true,
        text: '正在办理业务',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.$service.CarrierService
        .addMobilePackage(_formData)
        .then(res => {
          if (res.data.success) {
            if (window._czc) {
              window._czc.push(['_trackEvent', '宁夏', '提交表单', '流量权益包', 1, '成功'])
            }
            try{
              // eslint-disable-next-line
              if (window.countLog) {
                // eslint-disable-next-line
                countLog.ready(function() {
                  // eslint-disable-next-line
                  countLog.init(function() { 
                    // 如果需要跳转，在此处写入 window.location.href = 跳转链接 
                  }, {
                    // 是否需要复制订单号，是为 1，不是为 0 
                    isCopy: 0, 
                    // 上报转化类型，具体见下表 
                    pageType: 0 
                  })
                })
              }
            } catch (err) {
              console.log(err)
              this.errlog = err.message;
            }
            this.$message({
              type: 'success',
              message: '办理成功'
            })
            this.$router.push({
              name: 'nxSuccess'
            })
          } else {
            if (window._czc) {
              window._czc.push(['_trackEvent', '宁夏', '提交表单', '流量权益包', 0, '失败'])
            }
            if (this.failCount >= 1) {
              let _tip = ''
              switch(res.data.message) {
                case '号码异常，或者用户号码没有订购任何商品':
                case '其它错误!':
                  _tip = '办理失败！仅限宁夏移动用户办理。'
                  break
                default:
                  _tip = '办理失败！欠费停机或重复订购。'
              }
              location.href = '/normal.html#/result?tip=' + encodeURIComponent(_tip)
            } else {
              this.failCount += 1
              this.$message({
                type: 'warning',
                message: res.data.message
              })
            }
          }
        })
        .catch(() => {
          if (window._czc) {
            window._czc.push(['_trackEvent', '宁夏', '提交表单', '流量权益包', 0, '失败'])
          }
          this.$message({
            type: 'error',
            message: '办理失败，请稍后再再试'
          })
        })
        .finally(() => {
          _loading.close()
        })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="less" scope>
.container{
  background-color: #F4A259;
  padding-bottom: 3.5rem;
}
.header{
  .banner{
    width: 100%;
  }
}
.module-bg{
  width: 90%;
  margin: 0 auto;
  border: 2px solid #48c89f;
  border-radius: 6px;
  padding: 6px;
  background-color: #ffffff;
}
@keyframes buttonheartbeat{
  0%{
    transform: scale3d(1,1,1);
  }
  20%{
    transform: scale3d(1.03,1.03,1.03);;
  }
  40%{
    transform: scale3d(.9,.9,.9);
  }
  60%{
    transform: scale3d(1.03,1.03,1.03);
  }
  80%{
    transform: scale3d(1.03,1.03,1.03);
  }
  100%{
    transform: scale3d(.97,.97,.97);
  }
}
.mobile-form{
  padding: 50px 48px;
  margin-top: -10px;
  background: url('https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/ningxia/o-form-bg.jpg?x-oss-process=style/414_jpeg_zoom');
  background-size: 100%;
  background-repeat: no-repeat;
  background-color: #E43151;
  .btn-submit{
    img{
      width: 100%;
      animation: buttonheartbeat 5s infinite;
    }
  }
}
.user-notice{
  margin-top: 12px;
  font-size: .8rem;
  color: #222;
  .title{
    color: #48c89f;
    font-size: 1rem;
  }
  .content{
    text-align: left;
    margin: 6px;
    ul{
      margin-left: .4rem;
    }
  }
}
.dialog-content{
  text-align: left;
  .mobile-info{
    color: #333;
    font-weight: bold;
  }
  .package-info{
    color: #e75e25;
    font-weight: bold;
  }
}
.share-ad{
  text-align: center;
  color: #a3a3a3;
  font-size: .9rem;
  img{
    width: 94%;
  }
}
.share-dialog{
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0px;
  background-color: rgba(0,0,0,.8);
  width: 100%;
  height: 900px;
}
.share-infos{
  color: #a3a3a3;
  font-size: .5rem;
}
.img-desc{
  img{
    width: 100%;
  }
}
.notice{
  padding-top: 1rem;
  color: #fff;
  .title{
    font-size: 1.4rem;
    text-align: center;
  }
  ul{
    width: 90%;
    margin: 0 auto;
    font-size: .8rem;
    padding: 1rem;
    li{
      clear: both;
      overflow: hidden;
      
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.protocal-content{
  color: #333;
  .title{
    font-size: 1.4rem;
    text-align: center;
  }
  ul{
    width: 90%;
    margin: 0 auto;
    font-size: .8rem;
    padding: 1rem;
    li{
      clear: both;
      overflow: hidden;
      
      margin-bottom: .2rem;
      .num{
        float: left;
        width: 1.4rem;
        line-height: 1.2rem;
      }
      .content{
        line-height: 1.2rem;
        margin-left: 1.3rem;

      }
    }
  }
}
.show-more{
  text-align: center;
  color: #333;
}
.protocol{
  text-align: center;
  *{
    font-size: 14px;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #fff;
  }
  .el-form-item__content{
    line-height: 20px;
  }
}
.el-form-item {
  margin-bottom: .4rem;
}
.ad{
  width: 90%;
  margin: 0 auto;
  background: #fff;
  padding: .5rem;
  border-radius: 6px;
  img{
    width: 100%;
  }
  .btn-submit{
    width: 100%;
    background-color: #ff810b;
    color: #fff;
    border: 0;
    margin-top: 10px;
    font-size: 1rem;
  }
}
.roll-order-infos{
  position: fixed;
  right: 0;
  top: 0;
  background-color: rgba(33, 33, 33, .6);
  color: #f3f3f3;
  font-size: .8rem;
  height: 2rem;
  overflow: hidden;
  padding: 0 1rem;
  width: 10rem;
  text-align: center;
  >div{
    margin: .5rem 0;
  }
  z-index: 1;
}
.price-desc{
  color: #fff;
  .el-form-item__content{
    line-height: 16px;
  }
}
</style>